module.exports = __webpack_public_path__ + "img/invoice_bankinfo_help.382159d4.png";